import { render, staticRenderFns } from "./SettingItem.vue?vue&type=template&id=e773bc98&scoped=true"
import script from "./SettingItem.vue?vue&type=script&lang=js"
export * from "./SettingItem.vue?vue&type=script&lang=js"
import style0 from "./SettingItem.vue?vue&type=style&index=0&id=e773bc98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_babel-core@7.0.0-bridge.0_@babel+core@7.29._a7b6b2d0a8f0803019d019baabfbdad7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e773bc98",
  null
  
)

export default component.exports